module.exports = __webpack_public_path__ + "img/VIETCOMBANK.6f782471.svg";